// Collection pagination
class Pagination extends HTMLElement {
  constructor() {
    super();
    this.loadMoreButton = this.querySelector(".load-more.button, .load-more.button.load-ajax");
    this.loadMoreButton.addEventListener("click", this.onloadMoreButtonClick.bind(this));
  }

  onloadMoreButtonClick(evt) {
    evt.preventDefault();
    this.renderProducts();
  }

  renderProducts() {
    const url = this.loadMoreButton.getAttribute("next-page-url");
    const sourceMainItemWrapDiv = document.querySelector("#product-grid, .blog-articles");
    const sourceLoadMoreButton = this.loadMoreButton;

    fetch(url, { method: "GET" })
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // instead of innerHTML += 
        const nextPageContent = doc.querySelectorAll(".product-grid .grid__item, .blog-articles .article");
        nextPageContent.forEach((el) => {
          sourceMainItemWrapDiv.appendChild(el);
        });

        // update pagination attributes
        const nextBtn = doc.querySelector(".load-more.button");
        if (nextBtn) {
          const dataCurrentPage = nextBtn.getAttribute("data-current-page");
          const nextPageurlCheck = nextBtn.getAttribute("next-page-url");

          sourceLoadMoreButton.setAttribute("next-page-url", nextPageurlCheck);
          sourceLoadMoreButton.setAttribute("data-current-page", dataCurrentPage);

          if (nextPageurlCheck === "empty") {
            this.classList.add("hide");
          }
        } else {
          this.classList.add("hide");
        }
      })
      .catch((errorMsg) => {
        console.log(errorMsg);
      });
  }
}

customElements.define("paginate-section", Pagination);
